import React from "react";
import "./Icons.css";

export const FavouriteIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <path d="M12 .587l3.668 7.568 8.332 1.151-6.064 5.828 1.48 8.279-7.416-3.967-7.417 3.967 1.481-8.279-6.064-5.828 8.332-1.151z" />
  </svg>
);

export const MyTeamIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g fill="#FFFFFF">
      <path d="M17.997 18h-.998c0-1.552.06-1.775-.88-1.993-1.438-.332-2.797-.645-3.293-1.729-.18-.396-.301-1.048.155-1.907 1.021-1.929 1.277-3.583.702-4.538-.672-1.115-2.707-1.12-3.385.017-.576.968-.316 2.613.713 4.512.465.856.348 1.51.168 1.908-.49 1.089-1.836 1.4-3.262 1.728-.982.227-.92.435-.92 2.002h-.995l-.002-.623c0-1.259.1-1.985 1.588-2.329 1.682-.389 3.344-.736 2.545-2.209-2.366-4.365-.676-6.839 1.865-6.839 2.492 0 4.227 2.383 1.867 6.839-.775 1.464.824 1.812 2.545 2.209 1.49.344 1.589 1.072 1.589 2.333l-.002.619zm4.81-2.214c-1.289-.298-2.489-.559-1.908-1.657 1.77-3.342.47-5.129-1.4-5.129-1.265 0-2.248.817-2.248 2.325 0 1.269.574 2.175.904 2.925h1.048c-.17-.75-1.466-2.562-.766-3.736.412-.692 1.704-.693 2.114-.012.38.631.181 1.812-.534 3.161-.388.733-.28 1.301-.121 1.648.305.666.977.987 1.737 1.208 1.507.441 1.368.042 1.368 1.48h.997l.002-.463c0-.945-.074-1.492-1.193-1.75zm-22.805 2.214h.997c0-1.438-.139-1.039 1.368-1.48.761-.221 1.433-.542 1.737-1.208.159-.348.267-.915-.121-1.648-.715-1.349-.914-2.53-.534-3.161.41-.682 1.702-.681 2.114.012.7 1.175-.596 2.986-.766 3.736h1.048c.33-.75.904-1.656.904-2.925.001-1.509-.982-2.326-2.247-2.326-1.87 0-3.17 1.787-1.4 5.129.581 1.099-.619 1.359-1.908 1.657-1.12.258-1.194.805-1.194 1.751l.002.463z" />
    </g>
  </svg>
);

export const FeedIcon = () => (
  <svg width="24px" height="24px" viewBox="0 0 23 23" version="1.1">
    <g fill="#FFFFFF">
      <path
        d="M18.225 0l-6.74 6.739L4.745 0 0 4.746l6.739 6.74.014.015-.013.012L0 18.254 4.746 23l6.74-6.74 6.74 6.74 4.745-4.746-6.74-6.74-.014-.015 6.754-6.753L18.225 0zm-5.974 7.504l5.974-5.973 3.215 3.215-5.975 5.974-3.214-3.216zm0 7.99l3.214-3.214 5.975 5.974-3.215 3.214-5.973-5.973z"
        stroke="none"
        strokeWidth="1"
        fillRule="evenodd"
      />
    </g>
  </svg>
);

export const AppsIcon = () => (
  <svg width="50" height="50" viewBox="0 0 50 50">
    <g fill="#FFFFFF">
      <path d="M17.661,19H12.339A1.341,1.341,0,0,1,11,17.661V12.339A1.341,1.341,0,0,1,12.339,11h5.321A1.341,1.341,0,0,1,19,12.339v5.321A1.341,1.341,0,0,1,17.661,19Zm-5.321-7a.344.344,0,0,0-.339.339v5.321a.344.344,0,0,0,.339.339h5.321A.344.344,0,0,0,18,17.661V12.339A.344.344,0,0,0,17.661,12Z" />
      <path d="M37.661,19H32.339A1.34,1.34,0,0,1,31,17.661V12.339A1.34,1.34,0,0,1,32.339,11h5.322A1.34,1.34,0,0,1,39,12.339v5.321A1.34,1.34,0,0,1,37.661,19Zm-5.322-7a.344.344,0,0,0-.339.339v5.321a.344.344,0,0,0,.339.339h5.322A.344.344,0,0,0,38,17.661V12.339A.344.344,0,0,0,37.661,12Z" />
      <path d="M27.661,19H22.339A1.341,1.341,0,0,1,21,17.661V12.339A1.341,1.341,0,0,1,22.339,11h5.322A1.34,1.34,0,0,1,29,12.339v5.321A1.34,1.34,0,0,1,27.661,19Zm-5.322-7a.344.344,0,0,0-.339.339v5.321a.344.344,0,0,0,.339.339h5.322A.344.344,0,0,0,28,17.661V12.339A.344.344,0,0,0,27.661,12Z" />
      <path d="M17.661,39H12.339A1.341,1.341,0,0,1,11,37.661V32.339A1.341,1.341,0,0,1,12.339,31h5.321A1.341,1.341,0,0,1,19,32.339v5.321A1.341,1.341,0,0,1,17.661,39Zm-5.321-7a.344.344,0,0,0-.339.339v5.321a.344.344,0,0,0,.339.339h5.321A.344.344,0,0,0,18,37.661V32.339A.344.344,0,0,0,17.661,32Z" />
      <path d="M37.661,39H32.339A1.34,1.34,0,0,1,31,37.661V32.339A1.34,1.34,0,0,1,32.339,31h5.322A1.34,1.34,0,0,1,39,32.339v5.321A1.34,1.34,0,0,1,37.661,39Zm-5.322-7a.344.344,0,0,0-.339.339v5.321a.344.344,0,0,0,.339.339h5.322A.344.344,0,0,0,38,37.661V32.339A.344.344,0,0,0,37.661,32Z" />
      <path d="M27.661,39H22.339A1.341,1.341,0,0,1,21,37.661V32.339A1.341,1.341,0,0,1,22.339,31h5.322A1.34,1.34,0,0,1,29,32.339v5.321A1.34,1.34,0,0,1,27.661,39Zm-5.322-7a.344.344,0,0,0-.339.339v5.321a.344.344,0,0,0,.339.339h5.322A.344.344,0,0,0,28,37.661V32.339A.344.344,0,0,0,27.661,32Z" />
      <path d="M17.661,29H12.339A1.341,1.341,0,0,1,11,27.661V22.339A1.341,1.341,0,0,1,12.339,21h5.321A1.341,1.341,0,0,1,19,22.339v5.321A1.341,1.341,0,0,1,17.661,29Zm-5.321-7a.344.344,0,0,0-.339.339v5.321a.344.344,0,0,0,.339.339h5.321A.344.344,0,0,0,18,27.661V22.339A.344.344,0,0,0,17.661,22Z" />
      <path d="M37.661,29H32.339A1.34,1.34,0,0,1,31,27.661V22.339A1.34,1.34,0,0,1,32.339,21h5.322A1.34,1.34,0,0,1,39,22.339v5.321A1.34,1.34,0,0,1,37.661,29Zm-5.322-7a.344.344,0,0,0-.339.339v5.321a.344.344,0,0,0,.339.339h5.322A.344.344,0,0,0,38,27.661V22.339A.344.344,0,0,0,37.661,22Z" />
      <path d="M27.661,29H22.339A1.341,1.341,0,0,1,21,27.661V22.339A1.341,1.341,0,0,1,22.339,21h5.322A1.34,1.34,0,0,1,29,22.339v5.321A1.34,1.34,0,0,1,27.661,29Zm-5.322-7a.344.344,0,0,0-.339.339v5.321a.344.344,0,0,0,.339.339h5.322A.344.344,0,0,0,28,27.661V22.339A.344.344,0,0,0,27.661,22Z" />
    </g>
  </svg>
);

export const AppIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <g fill="#FFFFFF">
      <path d="M22 6v16h-20v-16h20zm2-6h-24v24h24v-24zm-16 9h-4v4h4v-4zm6 0h-4v4h4v-4zm6 0h-4v4h4v-4zm-12 6h-4v4h4v-4zm6 0h-4v4h4v-4z" />
    </g>
  </svg>
);

export const FlowerIcon = () => (
  <svg width="24" height="24" fillRule="evenodd" clipRule="evenodd">
    <g fill="#FFFFFF">
      <path d="M11.997 24c-6.438.012-9.21-7.697-10.997-8.879 6.163-2.661 9.556.165 11 2.589l.034-.057c1.463-2.41 4.851-5.172 10.966-2.532-1.787 1.182-4.559 8.891-10.997 8.879h-.006zm.006-2c4.096 0 7.328-5.716 7.328-5.716-2.299-.522-4.16.193-7.258 4.59l-.073.105c-3.141-4.491-5.014-5.221-7.331-4.695 0 0 3.232 5.716 7.328 5.716h.006zm.05-7c-1.405 0-2.615-.863-3.125-2.087-1.337.172-2.695-.493-3.37-1.663-.703-1.216-.56-2.696.245-3.75-.805-1.054-.947-2.534-.245-3.751.675-1.17 2.039-1.837 3.371-1.662.51-1.224 1.719-2.087 3.124-2.087 1.404 0 2.614.863 3.125 2.087 1.333-.176 2.694.492 3.371 1.662.701 1.217.558 2.697-.246 3.751.804 1.054.947 2.533.246 3.75-.677 1.17-2.038 1.834-3.371 1.663-.511 1.224-1.721 2.087-3.125 2.087zm-1.391-5.09l.008 1.713c.003.76.624 1.377 1.383 1.377s1.38-.617 1.383-1.376l.008-1.71 1.487.846c.643.367 1.521.123 1.885-.51.38-.657.156-1.504-.501-1.886l-1.48-.864 1.48-.864c.657-.382.881-1.229.501-1.887-.364-.631-1.244-.874-1.883-.509l-1.489.852-.008-1.716c-.003-.758-.624-1.376-1.383-1.376s-1.38.618-1.383 1.376l-.008 1.714-1.488-.849c-.641-.368-1.518-.123-1.884.508-.38.659-.155 1.505.5 1.887l1.481.864-1.481.864c-.655.382-.88 1.228-.5 1.886.366.633 1.245.877 1.884.51l1.488-.85zm1.338-4.431c1.104 0 2 .896 2 2s-.896 2-2 2-2-.896-2-2 .896-2 2-2z" />
    </g>
  </svg>
);

export const GearsIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <g fill="#FFFFFF">
      <path d="M17 10.645v-2.29c-1.17-.417-1.907-.533-2.28-1.431-.373-.9.07-1.512.6-2.625l-1.618-1.619c-1.105.525-1.723.974-2.626.6-.9-.373-1.017-1.116-1.431-2.28h-2.29c-.412 1.158-.53 1.907-1.431 2.28h-.001c-.9.374-1.51-.07-2.625-.6l-1.617 1.619c.527 1.11.973 1.724.6 2.625-.375.901-1.123 1.019-2.281 1.431v2.289c1.155.412 1.907.531 2.28 1.431.376.908-.081 1.534-.6 2.625l1.618 1.619c1.107-.525 1.724-.974 2.625-.6h.001c.9.373 1.018 1.118 1.431 2.28h2.289c.412-1.158.53-1.905 1.437-2.282h.001c.894-.372 1.501.071 2.619.602l1.618-1.619c-.525-1.107-.974-1.723-.601-2.625.374-.899 1.126-1.019 2.282-1.43zm-8.5 1.689c-1.564 0-2.833-1.269-2.833-2.834s1.269-2.834 2.833-2.834 2.833 1.269 2.833 2.834-1.269 2.834-2.833 2.834zm15.5 4.205v-1.077c-.55-.196-.897-.251-1.073-.673-.176-.424.033-.711.282-1.236l-.762-.762c-.52.248-.811.458-1.235.283-.424-.175-.479-.525-.674-1.073h-1.076c-.194.545-.25.897-.674 1.073-.424.176-.711-.033-1.235-.283l-.762.762c.248.523.458.812.282 1.236-.176.424-.528.479-1.073.673v1.077c.544.193.897.25 1.073.673.177.427-.038.722-.282 1.236l.762.762c.521-.248.812-.458 1.235-.283.424.175.479.526.674 1.073h1.076c.194-.545.25-.897.676-1.074h.001c.421-.175.706.034 1.232.284l.762-.762c-.247-.521-.458-.812-.282-1.235s.529-.481 1.073-.674zm-4 .794c-.736 0-1.333-.597-1.333-1.333s.597-1.333 1.333-1.333 1.333.597 1.333 1.333-.597 1.333-1.333 1.333zm-4 3.071v-.808c-.412-.147-.673-.188-.805-.505s.024-.533.212-.927l-.572-.571c-.389.186-.607.344-.926.212s-.359-.394-.506-.805h-.807c-.146.409-.188.673-.506.805-.317.132-.533-.024-.926-.212l-.572.571c.187.393.344.609.212.927-.132.318-.396.359-.805.505v.808c.408.145.673.188.805.505.133.32-.028.542-.212.927l.572.571c.39-.186.608-.344.926-.212.318.132.359.395.506.805h.807c.146-.409.188-.673.507-.805h.001c.315-.131.529.025.924.213l.572-.571c-.186-.391-.344-.609-.212-.927s.397-.361.805-.506zm-3 .596c-.552 0-1-.447-1-1s.448-1 1-1 1 .447 1 1-.448 1-1 1z" />
    </g>
  </svg>
);

export const EmailIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <g fill="#FFFFFF">
      <path d="M0 3v18h24v-18h-24zm6.623 7.929l-4.623 5.712v-9.458l4.623 3.746zm-4.141-5.929h19.035l-9.517 7.713-9.518-7.713zm5.694 7.188l3.824 3.099 3.83-3.104 5.612 6.817h-18.779l5.513-6.812zm9.208-1.264l4.616-3.741v9.348l-4.616-5.607z" />
    </g>
  </svg>
);

export const SearchIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <g fill="#FFFFFF">
      <path d="M23.822 20.88l-6.353-6.354c.93-1.465 1.467-3.2 1.467-5.059.001-5.219-4.247-9.467-9.468-9.467s-9.468 4.248-9.468 9.468c0 5.221 4.247 9.469 9.468 9.469 1.768 0 3.421-.487 4.839-1.333l6.396 6.396 3.119-3.12zm-20.294-11.412c0-3.273 2.665-5.938 5.939-5.938 3.275 0 5.94 2.664 5.94 5.938 0 3.275-2.665 5.939-5.94 5.939-3.274 0-5.939-2.664-5.939-5.939z" />
    </g>
  </svg>
);

export const ZoomIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <g fill="#FFFFFF">
      <path d="M13 10h-3v3h-2v-3h-3v-2h3v-3h2v3h3v2zm8.172 14l-7.387-7.387c-1.388.874-3.024 1.387-4.785 1.387-4.971 0-9-4.029-9-9s4.029-9 9-9 9 4.029 9 9c0 1.761-.514 3.398-1.387 4.785l7.387 7.387-2.828 2.828zm-12.172-8c3.859 0 7-3.14 7-7s-3.141-7-7-7-7 3.14-7 7 3.141 7 7 7z" />{" "}
    </g>
  </svg>
);

export const PluginIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g fill="#FFFFFF">
      <path d="M9.916 8.195h-.013v.961c-.034 1.598 4.213 1.601 4.161 0v-.96c-.123-1.511-4.042-1.52-4.148-.001zm2.08.71c-.723 0-1.311-.253-1.311-.564 0-.312.588-.564 1.311-.564.724 0 1.311.253 1.311.564 0 .311-.587.564-1.311.564zm6.421-2.155v-.96c-.124-1.511-4.042-1.52-4.148-.001h-.013v.961c-.034 1.599 4.214 1.602 4.161 0zm-2.067-1.379c.723 0 1.311.253 1.311.564s-.589.565-1.311.565c-.724 0-1.311-.253-1.311-.564s.587-.565 1.311-.565zm-10.797.418h-.013v.961c-.034 1.598 4.213 1.601 4.161 0v-.96c-.123-1.511-4.042-1.519-4.148-.001zm2.08.711c-.723 0-1.311-.253-1.311-.564s.588-.565 1.311-.565c.724 0 1.311.253 1.311.564s-.588.565-1.311.565zm2.283-2.988l-.013.201v.759c-.034 1.598 4.214 1.602 4.161 0v-.959c-.124-1.512-4.042-1.52-4.148-.001zm3.392.145c0 .311-.588.564-1.311.564-.724 0-1.311-.253-1.311-.564s.587-.564 1.311-.564c.723 0 1.311.253 1.311.564zm-1.308-3.657l-11 6 .009.019-.009-.005v12.118l11 5.868 11-5.869v-12.055l-11-6.076zm-1 21l-8-4.268v-7.133l8 4.401v7zm-8.885-14.464l9.882-5.396 9.917 5.458-9.896 5.385-9.903-5.447zm10.885 7.464l8-4.353v7.085l-8 4.268v-7z" />
    </g>
  </svg>
);

export const FolderIcon = () => (
  <svg width="30" height="30" viewBox="0 0 24 24">
    <g fill="#FFFFFF">
      <path d="M6.083 4c1.38 1.612 2.578 3 4.917 3h11v13h-20v-16h4.083zm.917-2h-7v20h24v-17h-13c-1.629 0-2.305-1.058-4-3z" />
    </g>
  </svg>
);

export const BoldIcon = () => (
  <svg width="50" height="50" viewBox="0 0 384 512">
    <g fill="#FFFFFF">
      <path d="M304.793 243.891c33.639-18.537 53.657-54.16 53.657-95.693 0-48.236-26.25-87.626-68.626-104.179C265.138 34.01 240.849 32 209.661 32H24c-8.837 0-16 7.163-16 16v33.049c0 8.837 7.163 16 16 16h33.113v318.53H24c-8.837 0-16 7.163-16 16V464c0 8.837 7.163 16 16 16h195.69c24.203 0 44.834-1.289 66.866-7.584C337.52 457.193 376 410.647 376 350.014c0-52.168-26.573-91.684-71.207-106.123zM142.217 100.809h67.444c16.294 0 27.536 2.019 37.525 6.717 15.828 8.479 24.906 26.502 24.906 49.446 0 35.029-20.32 56.79-53.029 56.79h-76.846V100.809zm112.642 305.475c-10.14 4.056-22.677 4.907-31.409 4.907h-81.233V281.943h84.367c39.645 0 63.057 25.38 63.057 63.057.001 28.425-13.66 52.483-34.782 61.284z" />
    </g>
  </svg>
);

export const ItalicIcon = () => (
  <svg width="50" height="50" viewBox="0 0 320 512">
    <g fill="#FFFFFF">
      <path d="M204.758 416h-33.849l62.092-320h40.725a16 16 0 0 0 15.704-12.937l6.242-32C297.599 41.184 290.034 32 279.968 32H120.235a16 16 0 0 0-15.704 12.937l-6.242 32C96.362 86.816 103.927 96 113.993 96h33.846l-62.09 320H46.278a16 16 0 0 0-15.704 12.935l-6.245 32C22.402 470.815 29.967 480 40.034 480h158.479a16 16 0 0 0 15.704-12.935l6.245-32c1.927-9.88-5.638-19.065-15.704-19.065z" />
    </g>
  </svg>
);

export const UnderlineIcon = () => (
  <svg width="50" height="50" viewBox="0 -20 448 512">
    <g fill="#FFFFFF">
      <path d="M224.264 388.24c-91.669 0-156.603-51.165-156.603-151.392V64H39.37c-8.837 0-16-7.163-16-16V16c0-8.837 7.163-16 16-16h137.39c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16h-28.813v172.848c0 53.699 28.314 79.444 76.317 79.444 46.966 0 75.796-25.434 75.796-79.965V64h-28.291c-8.837 0-16-7.163-16-16V16c0-8.837 7.163-16 16-16h136.868c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16h-28.291v172.848c0 99.405-64.881 151.392-156.082 151.392zM16 448h416c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16H16c-8.837 0-16-7.163-16-16v-32c0-8.837 7.163-16 16-16z" />{" "}
    </g>
  </svg>
);

export const HeaderIcon = () => (
  <svg width="50" height="50" viewBox="0 0 512 512">
    <g fill="#FFFFFF">
      <path d="M496 80V48c0-8.837-7.163-16-16-16H320c-8.837 0-16 7.163-16 16v32c0 8.837 7.163 16 16 16h37.621v128H154.379V96H192c8.837 0 16-7.163 16-16V48c0-8.837-7.163-16-16-16H32c-8.837 0-16 7.163-16 16v32c0 8.837 7.163 16 16 16h37.275v320H32c-8.837 0-16 7.163-16 16v32c0 8.837 7.163 16 16 16h160c8.837 0 16-7.163 16-16v-32c0-8.837-7.163-16-16-16h-37.621V288H357.62v128H320c-8.837 0-16 7.163-16 16v32c0 8.837 7.163 16 16 16h160c8.837 0 16-7.163 16-16v-32c0-8.837-7.163-16-16-16h-37.275V96H480c8.837 0 16-7.163 16-16z" />{" "}
    </g>
  </svg>
);

export const UlIcon = () => (
  <svg width="50" height="50" viewBox="0 0 512 512">
    <g fill="#FFFFFF">
      <path d="M96 96c0 26.51-21.49 48-48 48S0 122.51 0 96s21.49-48 48-48 48 21.49 48 48zM48 208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm0 160c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm96-236h352c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H144c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h352c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H144c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h352c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H144c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z" />{" "}
    </g>
  </svg>
);

export const OlIcon = () => (
  <svg width="50" height="50" viewBox="0 0 512 512">
    <g fill="#FFFFFF">
      <path d="M3.263 139.527c0-7.477 3.917-11.572 11.573-11.572h15.131V88.078c0-5.163.534-10.503.534-10.503h-.356s-1.779 2.67-2.848 3.738c-4.451 4.273-10.504 4.451-15.666-1.068l-5.518-6.231c-5.342-5.341-4.984-11.216.534-16.379l21.72-19.938C32.815 33.602 36.732 32 42.785 32H54.89c7.656 0 11.749 3.916 11.749 11.572v84.384h15.488c7.655 0 11.572 4.094 11.572 11.572v8.901c0 7.477-3.917 11.572-11.572 11.572H14.836c-7.656 0-11.573-4.095-11.573-11.572v-8.902zM2.211 304.591c0-47.278 50.955-56.383 50.955-69.165 0-7.18-5.954-8.755-9.28-8.755-3.153 0-6.479 1.051-9.455 3.852-5.079 4.903-10.507 7.004-16.111 2.451l-8.579-6.829c-5.779-4.553-7.18-9.805-2.803-15.409C13.592 201.981 26.025 192 47.387 192c19.437 0 44.476 10.506 44.476 39.573 0 38.347-46.753 46.402-48.679 56.909h39.049c7.529 0 11.557 4.027 11.557 11.382v8.755c0 7.354-4.028 11.382-11.557 11.382h-67.94c-7.005 0-12.083-4.028-12.083-11.382v-4.028zM5.654 454.61l5.603-9.28c3.853-6.654 9.105-7.004 15.584-3.152 4.903 2.101 9.63 3.152 14.359 3.152 10.155 0 14.358-3.502 14.358-8.23 0-6.654-5.604-9.106-15.934-9.106h-4.728c-5.954 0-9.28-2.101-12.258-7.88l-1.05-1.926c-2.451-4.728-1.226-9.806 2.801-14.884l5.604-7.004c6.829-8.405 12.257-13.483 12.257-13.483v-.35s-4.203 1.051-12.608 1.051H16.685c-7.53 0-11.383-4.028-11.383-11.382v-8.755c0-7.53 3.853-11.382 11.383-11.382h58.484c7.529 0 11.382 4.027 11.382 11.382v3.327c0 5.778-1.401 9.806-5.079 14.183l-17.509 20.137c19.611 5.078 28.716 20.487 28.716 34.845 0 21.363-14.358 44.126-48.503 44.126-16.636 0-28.192-4.728-35.896-9.455-5.779-4.202-6.304-9.805-2.626-15.934zM144 132h352c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H144c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h352c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H144c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h352c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H144c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z" />{" "}
    </g>
  </svg>
);

export const CalendarIcon = () => (
  <svg width="50" height="50" viewBox="0 0 50 50">
    <g fill="#FFFFFF">
      <path d="M37.5,13H35V12a.99.99,0,0,0-1-1H32a.99.99,0,0,0-1,1v1H19V12a.99.99,0,0,0-1-1H16a.99.99,0,0,0-1,1v1H12.5A1.5,1.5,0,0,0,11,14.5v23A1.5,1.5,0,0,0,12.5,39h25A1.5,1.5,0,0,0,39,37.5v-23A1.5,1.5,0,0,0,37.5,13ZM32,12h2v3H32ZM16,12h2v3H16ZM38,37.5a.5.5,0,0,1-.5.5h-25a.5.5,0,0,1-.5-.5V19H38ZM38,18H12V14.5a.5.5,0,0,1,.5-.5H15v1a.99.99,0,0,0,1,1h2a.99.99,0,0,0,1-1V14H31v1a.99.99,0,0,0,1,1h2a.99.99,0,0,0,1-1V14h2.5a.5.5,0,0,1,.5.5Z" />
      <rect x="14" y="22" width="6" height="3" rx="1" ry="1" />
      <rect x="22" y="22" width="6" height="3" rx="1" ry="1" />
      <rect x="30" y="22" width="6" height="3" rx="1" ry="1" />
      <rect x="14" y="27" width="6" height="3" rx="1" ry="1" />
      <rect x="22" y="27" width="6" height="3" rx="1" ry="1" />
      <rect x="30" y="27" width="6" height="3" rx="1" ry="1" />
      <rect x="14" y="32" width="6" height="3" rx="1" ry="1" />
      <rect x="22" y="32" width="6" height="3" rx="1" ry="1" />
      <rect x="30" y="32" width="6" height="3" rx="1" ry="1" />
    </g>
  </svg>
);

export const ReportingIcon = () => (
  <svg width="29" height="26" version="1.1">
    <g fillRule="nonzero" stroke="none" strokeWidth="1" fill="none">
      <path d="M19 3a1.009 1.009 0 0 1-1.14.99.993.993 0 0 1-.81-.7.866.866 0 0 1 0-.58.991.991 0 0 1 1.93.13v.01c.016.048.023.1.02.15z" />
      <path
        d="M23.5 25H0V.5a.5.5 0 1 1 1 0V24h22.5a.5.5 0 1 1 0 1z"
        fill="#181F79"
      />
      <path
        d="M25 5a2 2 0 0 0-1.49.67l-3.56-2.22A2 2 0 1 0 16 3c-.002.54.218 1.058.61 1.43L11.9 17.01a1.89 1.89 0 0 0-1.09.38l-2.99-2.57c.12-.256.182-.537.18-.82a2 2 0 1 0-2 2c.428.003.846-.134 1.19-.39l2.99 2.57c-.12.256-.182.537-.18.82a2 2 0 1 0 2.9-1.79l4.6-12.28c.162.048.33.072.5.07a2 2 0 0 0 1.49-.67l3.56 2.22A2 2 0 1 0 25 5zM6.99 14.11A1 1 0 0 1 5 14a.93.93 0 0 1 .05-.29c.09-.32.34-.57.66-.66A.928.928 0 0 1 6 13a1 1 0 0 1 1 1 .375.375 0 0 1-.01.11zM13 19a.93.93 0 0 1-.05.29c-.09.32-.34.57-.66.66a.866.866 0 0 1-.58 0 .968.968 0 0 1-.66-.67v-.01A.619.619 0 0 1 11 19a.374.374 0 0 1 .01-.11.936.936 0 0 1 .45-.72.01.01 0 0 1 .01-.01.5.5 0 0 1 .14-.08A1 1 0 0 1 13 19zm5.62-15.22a.977.977 0 0 1-.76.21.993.993 0 0 1-.81-.7.866.866 0 0 1 0-.58.991.991 0 0 1 1.93.13v.01c.016.048.023.1.02.15 0 .305-.14.593-.38.78zm7.33 3.51a.99.99 0 0 1-1.93-.14A.388.388 0 0 1 24 7c.005-.55.45-.995 1-1a1 1 0 0 1 1 1 .93.93 0 0 1-.05.29z"
        fill="#181F79"
      />
      <path d="M7 14a.375.375 0 0 1-.01.11A1 1 0 0 1 5 14a.93.93 0 0 1 .05-.29c.09-.32.34-.57.66-.66A.928.928 0 0 1 6 13a1 1 0 0 1 1 1z" />
      <path d="M13 19a.93.93 0 0 1-.05.29c-.09.32-.34.57-.66.66a.866.866 0 0 1-.58 0 .968.968 0 0 1-.66-.67v-.01A.619.619 0 0 1 11 19a.374.374 0 0 1 .01-.11.936.936 0 0 1 .45-.72.01.01 0 0 1 .01-.01.5.5 0 0 1 .14-.08A1 1 0 0 1 13 19z" />
      <path d="M26 7a.93.93 0 0 1-.05.29.99.99 0 0 1-1.93-.14A.388.388 0 0 1 24 7c.005-.55.45-.995 1-1a1 1 0 0 1 1 1z" />
      <path
        d="M28.85 25.15a.483.483 0 0 1 0 .7.483.483 0 0 1-.7 0L27 24.7l-1.15 1.15a.483.483 0 0 1-.7 0 .483.483 0 0 1 0-.7L26.3 24l-1.15-1.15a.495.495 0 0 1 .7-.7L27 23.3l1.15-1.15a.495.495 0 0 1 .7.7L27.7 24l1.15 1.15z"
        fill="#181F79"
      />
    </g>
  </svg>
);

export const BellIcon = () => (
  <svg width="50" height="50" viewBox="0 0 50 50">
    <g fill="#FFFFFF">
      <path d="M19.5,17.4a.5.5,0,0,1-.367-.84A8.025,8.025,0,0,1,25,14a.5.5,0,0,1,0,1,7.023,7.023,0,0,0-5.134,2.241A.5.5,0,0,1,19.5,17.4Z" />
      <path d="M37.9,33.23a2.954,2.954,0,0,0-.78-1.35,2.789,2.789,0,0,0-.8-.57C35.54,29.56,35,25.08,35,22a10.033,10.033,0,0,0-8.01-9.79A1.474,1.474,0,0,0,27,12a2,2,0,0,0-4,0,1.274,1.274,0,0,0,.01.2A10.05,10.05,0,0,0,15,22c0,3.08-.54,7.57-1.32,9.31a3.041,3.041,0,0,0-1.59,1.93A3.288,3.288,0,0,0,12,34a3,3,0,0,0,3,3h6.13a4,4,0,0,0,7.74,0H35a3.009,3.009,0,0,0,3-3A2.964,2.964,0,0,0,37.9,33.23ZM24,12a1,1,0,0,1,2,0v.05a2.45,2.45,0,0,0-.27-.02c-.24-.02-.48-.03-.73-.03h-.06q-.36,0-.69.03c-.09.01-.17.01-.25.02Zm1,27a3.007,3.007,0,0,1-2.82-2h5.65A3.029,3.029,0,0,1,25,39Zm10-3H15a1.981,1.981,0,0,1-2-2,2.158,2.158,0,0,1,.06-.51,2.025,2.025,0,0,1,1.18-1.34.529.529,0,0,0,.26-.23c.98-1.93,1.5-7,1.5-9.92a9.035,9.035,0,0,1,7.71-8.91,9.77,9.77,0,0,1,2.03-.06c.19.02.38.04.56.07A9.017,9.017,0,0,1,34,22c0,2.92.52,7.99,1.5,9.92a.529.529,0,0,0,.27.24,1.9,1.9,0,0,1,1.16,1.32A1.861,1.861,0,0,1,37,34,2.006,2.006,0,0,1,35,36Z" />
      <path d="M33.5,32h-5a.5.5,0,0,1,0-1h5a.5.5,0,0,1,0,1Z" />
      <path d="M26.5,32h-2a.5.5,0,0,1,0-1h2a.5.5,0,0,1,0,1Z" />
    </g>
  </svg>
);

export const IconBubble = ({ icon, number }) => (
  <div className="IconBubble">
    {icon}
    {number >= 20 ? (
      <div className="IconBubble__Bubble">20+</div>
    ) : number > 0 ? (
      <div className="IconBubble__Bubble">{number}</div>
    ) : (
      <div />
    )}
  </div>
);

export const PlusIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <g fill="#FFFFFF">
      <path d="M24 9h-9v-9h-6v9h-9v6h9v9h6v-9h9z" />
    </g>
  </svg>
);

export const MinusIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <g fill="#FFFFFF">
      <path d="M0 9h24v6h-24z" />
    </g>
  </svg>
);

export const JobAddIcon = () => (
  <svg width="50" height="50" viewBox="0 0 50 50">
    <g fill="#FFFFFF">
      <path d="M41,32.5a.5.5,0,0,1-.5.5H37v3.5a.5.5,0,0,1-1,0V33H32.5a.5.5,0,0,1,0-1H36V28.5a.5.5,0,0,1,1,0V32h3.5A.5.5,0,0,1,41,32.5Z" />
      <path d="M28.53,24.29l-4.24,4.24.01.01,4.24-4.24Z" />
      <path d="M28.53,25.71l-2.82,2.82.01.01,2.82-2.82ZM15.8,29.95l.01.01.7-.71Z" />
      <path d="M17.23,29.95h-.01a.119.119,0,0,1,.04.04A.137.137,0,0,0,17.23,29.95Z" />
      <path d="M36.5,25a7.388,7.388,0,0,0-5.17,2.09l-2.08-2.08,3.53-3.54,1.15-1.15,2.11-6.36-6.36,2.11-1.15,1.15L25,20.76l-7.78-7.78-4.24,4.24L20.76,25l-4.25,4.25-.7.71-1.41,1.4a3,3,0,0,0,2.11,5.12h.01a2.933,2.933,0,0,0,2.11-.88l6.38-6.35,4.03,4.03A7.5,7.5,0,1,0,36.5,25Zm-6.28-8.05,4.24-1.41-1.41,4.24-.27.27-2.83-2.83ZM18.64,21.46,19.7,20.4a.5.5,0,0,0,0-.7.5.5,0,0,0-.71,0l-1.05,1.06-1.42-1.42,1.76-1.76a.5.5,0,0,0,0-.71.483.483,0,0,0-.7,0l-1.77,1.76L14.4,17.22l2.82-2.82,7.07,7.07-2.82,2.82ZM17.92,34.9a1.934,1.934,0,0,1-1.4.58h-.01a2,2,0,0,1-1.99-2,1.973,1.973,0,0,1,.58-1.41l1.41-1.41c.1.09,2.79,2.78,2.83,2.83Zm6.38-6.36-4.25,4.24-2.79-2.79a.119.119,0,0,0-.04-.04h.01L29.24,17.93l2.83,2.83L28.54,24.3Zm1.41-.01,2.82-2.82.01.01,2.11,2.11a7.365,7.365,0,0,0-1.62,4.02l-3.31-3.31ZM36.5,39a6.508,6.508,0,0,1-6.15-4.41,5.964,5.964,0,0,1-.33-1.75A1.882,1.882,0,0,1,30,32.5a6.431,6.431,0,0,1,1.36-3.96,4.777,4.777,0,0,1,.68-.74A6.392,6.392,0,0,1,36.5,26a6.5,6.5,0,0,1,0,13Z" />
    </g>
  </svg>
);

export const CampaignAddIcon = () => (
  <svg width="50" height="50" viewBox="0 0 50 50">
    <g fill="#FFFFFF">
      <path d="M41,32.5a.5.5,0,0,1-.5.5H37v3.5a.5.5,0,0,1-1,0V33H32.5a.5.5,0,0,1,0-1H36V28.5a.5.5,0,0,1,1,0V32h3.5A.5.5,0,0,1,41,32.5Z" />
      <path d="M36.5,25a7.484,7.484,0,0,0-1.5.15V15.06L29.87,11H20.23A1.229,1.229,0,0,0,19,12.23V14H17.23A1.229,1.229,0,0,0,16,15.23V17H14.23A1.229,1.229,0,0,0,13,18.23V37.77A1.229,1.229,0,0,0,14.23,39H27.77A1.229,1.229,0,0,0,29,37.77V36h.88A7.5,7.5,0,1,0,36.5,25ZM30,12.38,33.32,15H30ZM28,37.77a.24.24,0,0,1-.23.23H14.23a.24.24,0,0,1-.23-.23V18.23a.24.24,0,0,1,.23-.23H16V34.77A1.229,1.229,0,0,0,17.23,36H28ZM17.23,35a.24.24,0,0,1-.23-.23V15.23a.24.24,0,0,1,.23-.23H19V31.77A1.229,1.229,0,0,0,20.23,33h8.79a2.648,2.648,0,0,0,.02.28,7.065,7.065,0,0,0,.4,1.72Zm11.8-3.15c0,.05-.01.1-.01.15H20.23a.24.24,0,0,1-.23-.23V12.23a.24.24,0,0,1,.23-.23H29v3.3a.7.7,0,0,0,.7.7H34v9.44a6.417,6.417,0,0,0-1.67.85l-3.25-3.25L32,20.13V18H29.87l-2.91,2.92-3.83-3.83-2.12,2.12,3.83,3.83-2.77,2.77a1.491,1.491,0,0,0,0,2.12,1.467,1.467,0,0,0,1.06.44,1.451,1.451,0,0,0,1.06-.44l2.77-2.77,3.26,3.26A7.376,7.376,0,0,0,29.03,31.85ZM27.66,21.62,30.29,19H31v.71l-2.62,2.63-4.89,4.89a.509.509,0,0,1-.72-.72l2.77-2.77Zm-5.23-2.41.7-.7,3.12,3.12-.7.7Zm5.95,4.55,3.11,3.11-.7.7-3.11-3.11ZM36.5,39a6.528,6.528,0,0,1-5.49-3.02,6.949,6.949,0,0,1-.5-.98c-.06-.13-.11-.27-.16-.41A5.986,5.986,0,0,1,30.03,33a.859.859,0,0,1-.01-.16A1.882,1.882,0,0,1,30,32.5c0-.17.01-.34.02-.5a6.462,6.462,0,0,1,1.34-3.46,4.777,4.777,0,0,1,.68-.74A6.3,6.3,0,0,1,34,26.51a5.582,5.582,0,0,1,1-.33A6.162,6.162,0,0,1,36.5,26a6.5,6.5,0,0,1,0,13Z" />
      <path d="M27.66,21.62l-2.12,2.12.01.01,2.12-2.12Z" />
    </g>
  </svg>
);

export const CloseIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <g fill="#FFFFFF">
      <path d="M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z" />{" "}
    </g>
  </svg>
);

export const CloseIconThin = () => (
  <svg
    width="24"
    height="24"
    fill-rule="evenodd"
    clip-rule="evenodd"
    viewBox="0 0 24 24"
  >
    <g fill="#FFFFFF">
      <path d="M12 11.293l10.293-10.293.707.707-10.293 10.293 10.293 10.293-.707.707-10.293-10.293-10.293 10.293-.707-.707 10.293-10.293-10.293-10.293.707-.707 10.293 10.293z" />
    </g>
  </svg>
);

export const ArrowUpIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <g fill="#FFFFFF">
      <path d="M0 16.67l2.829 2.83 9.175-9.339 9.167 9.339 2.829-2.83-11.996-12.17z" />
    </g>
  </svg>
);

export const ArrowDownIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <g fill="#FFFFFF">
      <path d="M0 7.33l2.829-2.83 9.175 9.339 9.167-9.339 2.829 2.83-11.996 12.17z" />
    </g>
  </svg>
);

export const TriangleDownIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <g fill="#FFFFFF">
      <path d="M12 21l-12-18h24z" />
    </g>
  </svg>
);

export const CheckIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <g fill="#FFFFFF">
      <path d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z" />
    </g>
  </svg>
);

export const LockIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <g fill="#FFFFFF">
      <path d="M18 10v-4c0-3.313-2.687-6-6-6s-6 2.687-6 6v4h-3v14h18v-14h-3zm-10 0v-4c0-2.206 1.794-4 4-4s4 1.794 4 4v4h-8z" />
    </g>
  </svg>
);

export const ArrowLeftIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <g fill="#FFFFFF">
      <path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z" />
    </g>
  </svg>
);

export const ArrowRightIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <g fill="#FFFFFF">
      <path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z" />
    </g>
  </svg>
);

export const CheckboxIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <g fill="#FFFFFF">
      <path d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-1.959 17l-4.5-4.319 1.395-1.435 3.08 2.937 7.021-7.183 1.422 1.409-8.418 8.591z" />
    </g>
  </svg>
);

export const CheckFileIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <g fill="#FFFFFF">
      <path d="M4 22v-20h16v11.543c0 4.107-6 2.457-6 2.457s1.518 6-2.638 6h-7.362zm18-7.614v-14.386h-20v24h10.189c3.163 0 9.811-7.223 9.811-9.614zm-10.967.614c2.258-4.05 3.826-6.13 5.967-7.999l-.278-.641c-2.596 1.616-3.993 2.833-6.106 5.231-1.125-.802-1.76-1.169-2.76-1.654l-.856.792c1.711 1.585 2.64 2.631 4.033 4.271z" />{" "}
    </g>
  </svg>
);

export const ApproveFileIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <g fill="#FFFFFF">
      <path
        d="M17,4.4 C17,4.4 17,4.29 16.8835616,4.29 C16.8835616,4.18 16.7671233,4.18 16.6506849,4.07 L12.5753425,0.22 L12.4589041,0.11 C12.3424658,0.11 12.3424658,0 12.2260274,0 C12.109589,0 12.109589,0 11.9931507,0 C11.9931507,0 11.9931507,0 11.9931507,0 L1.74657534,0 C0.815068493,0 0,0.77 0,1.65 L0,20.35 C0,21.23 0.815068493,22 1.74657534,22 L15.1369863,22 C16.0684932,22 16.8835616,21.23 16.8835616,20.35 L16.8835616,4.62 C17,4.51 17,4.51 17,4.4 Z M12.6917808,1.87 L15.0205479,4.07 L12.6917808,4.07 L12.6917808,1.87 Z M15.8356164,20.35 C15.8356164,20.68 15.6027397,20.9 15.2534247,20.9 L1.74657534,20.9 C1.39726027,20.9 1.16438356,20.68 1.16438356,20.35 L1.16438356,1.65 C1.16438356,1.32 1.39726027,1.1 1.74657534,1.1 L11.4109589,1.1 L11.4109589,4.62 C11.4109589,4.95 11.6438356,5.17 11.9931507,5.17 L15.7191781,5.17 L15.7191781,20.35 L15.8356164,20.35 Z"
        id="Shape"
      />
      <path
        d="M12,11.1343429 C12,11.456766 11.76,11.6717147 11.4,11.6717147 L8.04,11.6717147 L9,12.5315095 C9.24,12.7464582 9.24,13.0688813 9,13.28383 C8.88,13.3913043 8.76,13.3913043 8.64,13.3913043 C8.52,13.3913043 8.28,13.3913043 8.16,13.28383 L6.12,11.456766 C6,11.3492916 6,11.2418173 6,11.0268686 C6,11.0268686 6,10.9193942 6,10.9193942 C6,10.9193942 6,10.8119199 6,10.8119199 C6,10.7044455 6.12,10.7044455 6.12,10.5969712 L8.16,8.76990718 C8.4,8.55495848 8.76,8.55495848 9,8.76990718 C9.24,8.98485589 9.24,9.30727894 9,9.52222765 L8.04,10.5969712 L11.4,10.5969712 C11.76,10.5969712 12,10.8119199 12,11.1343429 Z"
        id="Shape"
      />
    </g>
  </svg>
);

export const RejectFileIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <g fill="#FFFFFF">
      <path d="M18.5 15c-2.483 0-4.5 2.015-4.5 4.5s2.017 4.5 4.5 4.5 4.5-2.015 4.5-4.5-2.017-4.5-4.5-4.5zm2.5 5h-5v-1h5v1zm-7.18 4h-12.82v-24h10.189c3.163 0 9.811 7.223 9.811 9.614v3.887c-.623-.261-1.297-.422-2-.476v-2.569c0-4.106-6-2.456-6-2.456s1.518-6-2.638-6h-7.362v20h9.502c.312.749.764 1.424 1.318 2z" />
    </g>
  </svg>
);

export const CompareIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <g fill="#FFFFFF">
      <path d="M6 22v-16h16v7.543c0 4.107-6 2.457-6 2.457s1.518 6-2.638 6h-7.362zm18-7.614v-10.386h-20v20h10.189c3.163 0 9.811-7.223 9.811-9.614zm-10 1.614h-5v-1h5v1zm5-4h-10v1h10v-1zm0-3h-10v1h10v-1zm2-7h-19v19h-2v-21h21v2z" />
    </g>
  </svg>
);

export const DocumentIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <g fill="#FFFFFF">
      <path d="M4 22v-20h16v11.543c0 4.107-6 2.457-6 2.457s1.518 6-2.638 6h-7.362zm18-7.614v-14.386h-20v24h10.189c3.163 0 9.811-7.223 9.811-9.614zm-5-1.386h-10v-1h10v1zm0-4h-10v1h10v-1zm0-3h-10v1h10v-1z" />
    </g>
  </svg>
);

export const ShareIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <g fill="#FFFFFF">
      <path d="M6 17c2.269-9.881 11-11.667 11-11.667v-3.333l7 6.637-7 6.696v-3.333s-6.17-.171-11 5zm12 .145v2.855h-16v-12h6.598c.768-.787 1.561-1.449 2.339-2h-10.937v16h20v-6.769l-2 1.914z" />{" "}
    </g>
  </svg>
);

export const CircleIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <g fill="#FFFFFF">
      <path d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12z" />{" "}
    </g>
  </svg>
);

export const CircleFilledIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <g fill="#FFFFFF">
      <circle cx="12" cy="12" r="12" />
    </g>
  </svg>
);

export const DashboardIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <g fill="#FFFFFF">
      <path d="M20.021 12.593c-.141-.427-.314-.844-.516-1.242l-2.454 1.106c.217.394.39.81.517 1.242l2.453-1.106zm-12.573-.903c.271-.354.58-.675.919-.957l-1.89-1.969c-.328.294-.637.615-.918.957l1.889 1.969zm1.715-1.515c.379-.221.781-.396 1.198-.523l-1.034-2.569c-.41.142-.812.318-1.198.524l1.034 2.568zm-2.759 3.616c.121-.435.288-.854.498-1.25l-2.469-1.066c-.197.403-.364.822-.498 1.25l2.469 1.066zm9.434-6.2c-.387-.205-.79-.379-1.2-.519l-1.024 2.573c.417.125.82.299 1.2.519l1.024-2.573zm2.601 2.13c-.282-.342-.59-.663-.918-.957l-1.89 1.969c.339.282.647.604.918.957l1.89-1.969zm-5.791-3.059c-.219-.018-.437-.026-.649-.026s-.431.009-.65.026v2.784c.216-.025.434-.038.65-.038.216 0 .434.012.649.038v-2.784zm-.648 14.338c-1.294 0-2.343-1.049-2.343-2.343 0-.883.489-1.652 1.21-2.051l1.133-5.606 1.133 5.605c.722.399 1.21 1.168 1.21 2.051 0 1.295-1.049 2.344-2.343 2.344zm12-6c0 2.184-.586 4.233-1.61 5.999l-1.736-1.003c.851-1.471 1.346-3.174 1.346-4.996 0-5.523-4.477-10-10-10s-10 4.477-10 10c0 1.822.495 3.525 1.346 4.996l-1.736 1.003c-1.024-1.766-1.61-3.815-1.61-5.999 0-6.617 5.383-12 12-12s12 5.383 12 12z" />{" "}
    </g>
  </svg>
);

export const ClockIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <g fill="#FFFFFF">
      <path d="M24 12c0 6.627-5.373 12-12 12s-12-5.373-12-12h2c0 5.514 4.486 10 10 10s10-4.486 10-10-4.486-10-10-10c-2.777 0-5.287 1.141-7.099 2.977l2.061 2.061-6.962 1.354 1.305-7.013 2.179 2.18c2.172-2.196 5.182-3.559 8.516-3.559 6.627 0 12 5.373 12 12zm-13-6v8h7v-2h-5v-6h-2z" />
    </g>
  </svg>
);

export const PencilIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <g fill="#FFFFFF">
      <path d="M18.363 8.464l1.433 1.431-12.67 12.669-7.125 1.436 1.439-7.127 12.665-12.668 1.431 1.431-12.255 12.224-.726 3.584 3.584-.723 12.224-12.257zm-.056-8.464l-2.815 2.817 5.691 5.692 2.817-2.821-5.693-5.688zm-12.318 18.718l11.313-11.316-.705-.707-11.313 11.314.705.709z" />{" "}
    </g>
  </svg>
);

export const CommentIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <g fill="#FFFFFF">
      <path d="M12 3c5.514 0 10 3.592 10 8.007 0 4.917-5.144 7.961-9.91 7.961-1.937 0-3.384-.397-4.394-.644-1 .613-1.594 1.037-4.272 1.82.535-1.373.722-2.748.601-4.265-.837-1-2.025-2.4-2.025-4.872 0-4.415 4.486-8.007 10-8.007zm0-2c-6.338 0-12 4.226-12 10.007 0 2.05.739 4.063 2.047 5.625.055 1.83-1.023 4.456-1.993 6.368 2.602-.47 6.301-1.508 7.978-2.536 1.417.345 2.774.503 4.059.503 7.084 0 11.91-4.837 11.91-9.961-.001-5.811-5.702-10.006-12.001-10.006z" />
    </g>
  </svg>
);

export const UploadIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <g fill="#FFFFFF">
      <path d="M17 22v2h-10v-2h10zm0-4h-10v2h10v-2zm-10-7v5h10v-5h6l-11-11-11 11h6z" />{" "}
    </g>
  </svg>
);

export const WhiteboardIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <g fill="#FFFFFF">
      <path d="M0 0v3h1v15h22v-15h1v-3h-24zm21 16h-18v-13h18v13zm-11.636 4l-2.736 4h-2.628l2.732-4h2.632zm10.636 4h-2.627l-2.736-4h2.632l2.731 4zm-11-10h-4v-4h4v4zm10 0h-4v-6h4v6zm-5 0h-4v-9h4v9z" />
    </g>
  </svg>
);

export const OperatorIcon = () => (
  <svg width="24" height="24" fillRule="evenodd" clipRule="evenodd">
    <g fill="#FFFFFF">
      <path d="M3 18h-2c-.552 0-1-.448-1-1v-2h15v-9h4.667c1.117 0 1.6.576 1.936 1.107.594.94 1.536 2.432 2.109 3.378.188.312.288.67.288 1.035v4.48c0 1.121-.728 2-2 2h-1c0 1.656-1.344 3-3 3s-3-1.344-3-3h-6c0 1.656-1.344 3-3 3s-3-1.344-3-3zm3-1.2c.662 0 1.2.538 1.2 1.2 0 .662-.538 1.2-1.2 1.2-.662 0-1.2-.538-1.2-1.2 0-.662.538-1.2 1.2-1.2zm12 0c.662 0 1.2.538 1.2 1.2 0 .662-.538 1.2-1.2 1.2-.662 0-1.2-.538-1.2-1.2 0-.662.538-1.2 1.2-1.2zm-4-2.8h-14v-10c0-.552.448-1 1-1h12c.552 0 1 .448 1 1v10zm3-6v3h4.715l-1.427-2.496c-.178-.312-.509-.504-.868-.504h-2.42z" />
    </g>
  </svg>
);

export const ChevronRight = () => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <g fill="#FFFFFF">
      <path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z" />
    </g>
  </svg>
);

export const ChevronLeft = () => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <g fill="#FFFFFF">
      <path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z" />
    </g>
  </svg>
);
